/**
 * @file  index.tsx
 * @description  app layout
 *
 * @author ogarcia (ozkary)
 *
 */
import { Layout } from 'antd';

/**
 * @description layout styled element
 *
 * @param Props
 */
export default Layout;
